export const config = {
 baseURL: 'https://defast-backend.bis-apps.com/',
 tokenKEY: 'token',
 phoneKEY: 'phone',
 backendTokenKEY: 'Authorization',
};
